/*
 * @Author: Zhouqi
 * @Date: 2025-11-27 15:54:33
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-09
 */
import dynamic from 'next/dynamic';

import FaceSwapSkeleton from '@/3.0/face-swap/_components/face-swap-skeleton';
import DelayedRender from '@/components/DelayRender';
import { withLayout } from '@/utils/withLayout';

const FaceSwapper = dynamic(() => import('../../3.0/face-swap/entry'), {
  ssr: false,
  loading: () => (
    <DelayedRender>
      <FaceSwapSkeleton />
    </DelayedRender>
  ),
});

const FaceSwapperPage: React.FC = () => {
  return (
    <>
      <FaceSwapper />
    </>
  );
};

export default withLayout(FaceSwapperPage);
